import { getError } from "@/utils/helpers";
import TeamService from "@/services/TeamService";

export const namespaced = true;

export const state = {
  teamsingle: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_TEAMSINGLE(state, teamsingle) {
    state.teamsingle = teamsingle;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getTeam({ commit }, UserId) {
    commit("SET_LOADING", true);

    TeamService.getTeam(UserId)
      .then((response) => {
        commit("SET_TEAMSINGLE", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
};
export const getters = {
  teamsingle: (state) => {
    return state.teamsingle;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
